// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"430":"22bbe035","639":"22bbe035","766":"22bbe035"}[chunkId] + ".chunk.css";
};